import React from 'react';

interface ChatBotIconProps {
  onClick: () => void;
}

const ChatBotIcon: React.FC<ChatBotIconProps> = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="fixed bottom-4 right-4 w-14 h-14 bg-[#1B3155] rounded-full cursor-pointer shadow-lg flex items-center justify-center hover:bg-[#2a477a] transition-colors duration-200"
      style={{ zIndex: 1000 }}
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z"
          fill="white"
        />
        <circle cx="8" cy="10" r="1.5" fill="white" />
        <circle cx="12" cy="10" r="1.5" fill="white" />
        <circle cx="16" cy="10" r="1.5" fill="white" />
      </svg>
    </div>
  );
};

export default ChatBotIcon;